import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

interface CarruselConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  imageCount?: number;
}

const CarruselConfirmModal: React.FC<CarruselConfirmModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  imageCount = 2,
}) => {
  if (!isOpen) return null;

  // Portaleado a document.body: la vista ampliada (lightbox) de las galerías se
  // renderiza con createPortal en el contexto raíz. Si este modal queda inline
  // dentro del shell `transform-gpu` de la app, su z-index queda atrapado en ese
  // stacking context y aparece POR DEBAJO del lightbox. Portalearlo lo lleva al
  // contexto raíz, donde su z-index sí gana.
  return createPortal(
    <div className="fixed inset-0 bg-brand-black/50 backdrop-blur-sm z-[9999] flex items-center justify-center px-4">
      <div
        className="bg-surface-card rounded-lg shadow-xl w-full max-w-sm overflow-hidden animate-in fade-in zoom-in-95 duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 pt-5 pb-0">
          <h3 className="text-[17px] font-semibold text-brand-black">Generar carrusel</h3>
          <button
            onClick={onCancel}
            className="w-8 h-8 flex items-center justify-center rounded-sm text-neutral-400 hover:text-neutral-600 hover:bg-neutral-100 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Illustration */}
        <div className="px-5 pt-3">
          <img
            src="/images/carrusel.png"
            alt="Ejemplo de carrusel"
            className="w-full rounded-md object-contain"
          />
        </div>

        {/* Body */}
        <div className="px-5 pt-3 pb-5">
          {/* Description */}
          <p className="text-[15px] text-brand-black/90 leading-snug mb-4">
            Se generarán <span className="font-semibold">{imageCount} imágenes nuevas</span> a partir de esta foto, con distintos ángulos y variaciones.
          </p>

          {/* Actions */}
          <div className="flex gap-2.5">
            <button
              onClick={onCancel}
              className="flex-1 h-10 px-4 inline-flex items-center justify-center rounded-md text-[15px] font-medium text-neutral-600 bg-surface-card border border-neutral-200 shadow-sm hover:bg-surface-elevated transition-colors"
            >
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 h-10 px-4 inline-flex items-center justify-center rounded-md text-[15px] font-medium text-white bg-brand-primary shadow-sm hover:bg-brand-primary-hover transition-colors"
            >
              Generar
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default CarruselConfirmModal;
